// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"b5045df134bce774","3833":"c0c02c3a48933754","3852":"999b493abc116a1c","6553":"c0c02c3a48933754"}[chunkId] + ".css";
};